/* eslint-disable */
import {
  HTTP_SERVICE_REQUEST_OBSERVE_BODY,
  HTTP_SERVICE_REQUEST_OBSERVE_EVENTS,
  HTTP_SERVICE_REQUEST_OBSERVE_RESPONSE,
} from '../../Constants/Http/Http.constants';
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the observe property of a http request is invalid
 * @export
 * @class HttpInvalidObserveError
 * @extends {Error}
 */
export class HttpInvalidObserveError extends Error {
  /**
   * Creates an instance of HttpInvalidObserveError
   * @param {string} message The Error `message`
   * @memberof HttpInvalidObserveError
   */
  constructor(message) {
    super(message);
    this.name = `HttpInvalidObserveError`;
  }
}

/**
 * Called when the observe property of a http request is invalid
 * @param {any} observe The http observe
 * @returns {never} never
 */
const throwHttpInvalidObserveError = (observe) => {
  if (observe === HTTP_SERVICE_REQUEST_OBSERVE_EVENTS) {
    throw new HttpInvalidObserveError(
      stripIndent(`
      The "observe" option provided is not supported.
      Got: "${observe}".
      `),
    );
  }
  throw new HttpInvalidObserveError(
    stripIndent(`
    Expected "observe" to be one of
      "${HTTP_SERVICE_REQUEST_OBSERVE_BODY}"
      "${HTTP_SERVICE_REQUEST_OBSERVE_EVENTS}"
      "${HTTP_SERVICE_REQUEST_OBSERVE_RESPONSE}"
    Got: "${observe}".
    `),
  );
};

export default throwHttpInvalidObserveError;
